import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { submitOnChangeTicketType } from '../handler/HelpdeskCreateTicketHandler';
import { submitOnchangeProject } from '../handler/QaTicketHandler';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export const DialogConfirmChangeTicketTypeDraftFlow = props => {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        if(props.isHelpDesk){
            props.setIsConfirmChangeTicketType(false);
        }
        if(props.isQA){
            props.setIsEdited(false);
            props.setIsOpenDialogQAConfirmChangeTicketType(false);
        }
    };

    const onHandlerConfirmChangeHelpDesk = () => {
        submitOnChangeTicketType(props.createTicketTypeSelectTemp, props);
        props.setIsConfirmChangeTicketType(false);

        // Reset external customer form data
        props.setExternalCustomerProjectList([]);
        props.setExternalCustomerRequestKeyword('');
        props.setExternalCustomerRequestProject({});
        props.setExternalCustomerProjectErr({
            error: false,
            helperText: ''
        });
    };

    const onHandlerConfirmChangeQA = () => {
        submitOnchangeProject(props.selectedProjectChange, props);
        props.setIsOpenDialogQAConfirmChangeTicketType(false);
        props.setIsEdited(false);
    };

    return (
        <Dialog
            open={props.isConfirmChangeTicketType}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    {props.isHelpDesk ? trI18n('USER04MSG022') : trI18n('USER04MSG016')}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button btn-hg32 btn-handle-delete-user-agree"
                    variant="contained"
                    onClick={props.isHelpDesk ? onHandlerConfirmChangeHelpDesk : (props.isQA ? onHandlerConfirmChangeQA : null)}
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="confirm-dialog-button btn-hg32"
                    variant="contained"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
